import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, TextArea } from 'semantic-ui-react';
import { FormField, FormLabel } from 'containers/RegistrationPage/formElements';
import {
  HORMONE_REPLACEMENT_MEDICINE,
  INDUCER_MEDICINE,
  OVARIAN_STIMULATION_MEDICINE,
} from 'utils/defaultOptions';
import {
  BUILD_TIMING_DRUG__PAYLOAD,
  DEFAULT_TIMING_DRUG_VALUES,
} from 'containers/TreatmentCyclePage/constants';

import { isValueInArray } from 'utils/helper';

const TimingDrugUsageForm = ({
  loadedData,
  isFormValid,
  otherDrugsLabel,
  updateFormValues,
}) => {
  const [formValues, setFormValues] = useState(DEFAULT_TIMING_DRUG_VALUES);
  useEffect(() => {
    if (loadedData) {
      const newFormValues = [];
      newFormValues.push(loadedData.ovarian_stimulant_medicine.map(elm => elm));
      newFormValues.push(
        loadedData.hormone_replacement_medicine.map(elm => elm),
      );
      newFormValues.push(loadedData.lh_surge_inducer_medicine.map(elm => elm));
      newFormValues.push(loadedData.other_medicine || '');
      newFormValues.push(loadedData.other_ovarian_stimulant_medicine || '');
      newFormValues.push(loadedData.other_hormone_replacement_medicine || '');
      newFormValues.push(loadedData.other_lh_surge_inducer_medicine || '');

      setFormValues(newFormValues);
    }
  }, [loadedData]);
  return (
    <>
      <Form.Group>
        <FormField style={{ paddingRight: 0 }}>
          <FormLabel htmlFor="hormone_replacement">卵巣刺激薬剤</FormLabel>
          <Form.Select
            placeholder="選択してください"
            options={OVARIAN_STIMULATION_MEDICINE}
            value={formValues[0]}
            multiple
            onChange={(evt, { value }) => {
              const newValues = formValues.map(formValue => formValue);
              newValues[0] = value.map(elm => elm);
              if (!isValueInArray(newValues[0], 15)) {
                newValues[4] = '';
              }
              setFormValues(newValues);
              const requestPayload = BUILD_TIMING_DRUG__PAYLOAD(...newValues);
              updateFormValues('medicine', requestPayload);
            }}
          />
        </FormField>
      </Form.Group>
      {isValueInArray(formValues[0], 15) && (
        <Form.Group style={{ marginBottom: 14 }} id="drugs_usage_form">
          <Form.Field
            control={TextArea}
            placeholder=""
            label="その他の卵巣刺激薬剤"
            value={formValues[4]}
            onChange={(evt, { value }) => {
              const newValues = formValues.map(formValue => formValue);
              newValues[4] = value;
              setFormValues(newValues);
              const requestPayload = BUILD_TIMING_DRUG__PAYLOAD(...newValues);
              updateFormValues('medicine', requestPayload);
            }}
          />
        </Form.Group>
      )}
      <Form.Group>
        <FormField style={{ paddingRight: 0 }}>
          <FormLabel htmlFor="hormone_drugs">ホルモン補充薬剤</FormLabel>
          <Form.Select
            placeholder="選択してください"
            options={HORMONE_REPLACEMENT_MEDICINE}
            value={formValues[1]}
            multiple
            onChange={(evt, { value }) => {
              const newValues = formValues.map(formValue => formValue);
              newValues[1] = value.map(elm => elm);
              if (!isValueInArray(newValues[1], 12)) {
                newValues[5] = '';
              }
              setFormValues(newValues);
              const requestPayload = BUILD_TIMING_DRUG__PAYLOAD(...newValues);
              updateFormValues('medicine', requestPayload);
            }}
          />
        </FormField>
      </Form.Group>
      {isValueInArray(formValues[1], 12) && (
        <Form.Group style={{ marginBottom: 14 }} id="drugs_usage_form">
          <Form.Field
            control={TextArea}
            placeholder=""
            label="その他のホルモン補充薬剤"
            value={formValues[5]}
            onChange={(evt, { value }) => {
              const newValues = formValues.map(formValue => formValue);
              newValues[5] = value;
              setFormValues(newValues);
              const requestPayload = BUILD_TIMING_DRUG__PAYLOAD(...newValues);
              updateFormValues('medicine', requestPayload);
            }}
          />
        </Form.Group>
      )}
      <Form.Group>
        <FormField style={{ paddingRight: 0 }}>
          <FormLabel htmlFor="treatment_period_results">
            LHサージ誘起薬剤
          </FormLabel>
          <Form.Select
            placeholder="選択してください"
            multiple
            value={formValues[2]}
            options={INDUCER_MEDICINE}
            onChange={(evt, { value }) => {
              const newValues = formValues.map(formValue => formValue);
              newValues[2] = value.map(elm => elm);
              if (!isValueInArray(newValues[2], 4)) {
                newValues[6] = '';
              }
              setFormValues(newValues);
              const requestPayload = BUILD_TIMING_DRUG__PAYLOAD(...newValues);
              updateFormValues('medicine', requestPayload);
              isFormValid(1, true);
            }}
          />
        </FormField>
      </Form.Group>
      {isValueInArray(formValues[2], 4) && (
        <Form.Group style={{ marginBottom: 14 }} id="drugs_usage_form">
          <Form.Field
            control={TextArea}
            placeholder=""
            label="その他のLHサージ誘起薬剤"
            value={formValues[6]}
            onChange={(evt, { value }) => {
              const newValues = formValues.map(formValue => formValue);
              newValues[6] = value;
              setFormValues(newValues);
              const requestPayload = BUILD_TIMING_DRUG__PAYLOAD(...newValues);
              updateFormValues('medicine', requestPayload);
            }}
          />
        </Form.Group>
      )}
      <Form.Group>
        <Form.Field style={{ paddingRight: 0 }}>
          <FormLabel htmlFor="other_stimulation">
            上記以外の種類の薬剤
          </FormLabel>
          <Form.TextArea
            name="other_stimulation"
            value={formValues[3]}
            placeholder={otherDrugsLabel}
            onChange={(evt, { value }) => {
              const newValues = formValues.map(formValue => formValue);
              newValues[3] = value;
              setFormValues(newValues);
              const requestPayload = BUILD_TIMING_DRUG__PAYLOAD(...newValues);
              updateFormValues('medicine', requestPayload);
              isFormValid(1, true);
            }}
          />
        </Form.Field>
      </Form.Group>
    </>
  );
};

TimingDrugUsageForm.propTypes = {
  loadedData: PropTypes.object,
  isFormValid: PropTypes.func.isRequired,
  otherDrugsLabel: PropTypes.string,
  updateFormValues: PropTypes.func.isRequired,
};
TimingDrugUsageForm.defaultProps = {
  loadedData: null,
};
export default TimingDrugUsageForm;
